import { createAction } from '../../techstyle-shared/redux-core';

export const trackSearchQuerySubmitted = createAction(
  'search/TRACK_QUERY_SUBMITTED'
);
